import type { FaireProductEntity } from "../../entity_types/product";

export const p_kcvj8n2f46: FaireProductEntity = {
  token: "p_kcvj8n2f46",
  type: "product",
  name: "Birth Year Necklace",
  brandToken: "b_eow5j1bbc8",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/df90e1bbc2a3335b4d2dfb8d803d14da3368703fefcb74a6f8f773c3bd339f68.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e871bcbc12d80ca904bb1cc4ff9c6e9d3308fc7d38d032791078bb18d55d6a4d.jpeg",
    "https://cdn.faire.com/fastly/0e9ec87a09aabe0f50623c0fd225347357178b2e7ac1107ad009292ac1b06174.jpeg",
    "https://cdn.faire.com/fastly/5ccc510ea0d680010aea2886627e9b0b6fc84a1119430fc468451746079c9ff2.jpeg",
    "https://cdn.faire.com/fastly/ada739ad0ad400c113a8862227af8755f487eafcfa258f6d8a0f71594dfbf0d4.jpeg",
    "https://cdn.faire.com/fastly/1e5a3598dca0c7c3a38ba9ee7d4772b4130c7ffb61cc59f704a76e4702b0a06e.jpeg",
    "https://cdn.faire.com/fastly/af640317d2afe88c49c60bacf9abd56589e6d581dd067c790b47321a45110695.jpeg",
    "https://cdn.faire.com/fastly/c9547c369a8c6150de57640e18641c15c41d3718c4f8f663a9dd5c01bae6fa9e.jpeg",
    "https://cdn.faire.com/fastly/2d7a7ab6619e8aed4173a718398e045bf7f6a89de5ebc7aa5016488e559ffb82.jpeg",
    "https://cdn.faire.com/fastly/02fab1f783eb3ea221f76198ebaf21b1010c7ff3609e128539031be3914266e4.jpeg",
    "https://cdn.faire.com/fastly/21d6fe6072d78785ef0aab47b238a6d35525b0bd0b3a96e0143050f9c0258090.jpeg",
    "https://cdn.faire.com/fastly/059022d8fd95b51a37a1ddcfa64c99ddca1ea8b35cf76894a52d63e00cf5bca1.jpeg",
    "https://cdn.faire.com/fastly/7d57c65a0b647b50b5075a26351b1551210ccbf18f94b8b88380b9d92a94f30c.jpeg",
    "https://cdn.faire.com/fastly/1265d5d0018cab105b7f12a5b7c2fd659e37435faadec65441784f64d5c28f5e.jpeg",
    "https://cdn.faire.com/fastly/c60ee21cea86b69179d73e898b037bc12cd56ea3742e2e3aba22c7299b357208.jpeg",
    "https://cdn.faire.com/fastly/85c1549d5eaaa9afc11bc6f22ec908b4371e15b3c329c739fc35299760271c9c.jpeg",
    "https://cdn.faire.com/fastly/1c522e332b7f84765fce72d5580554b9bd99c2e12e216ecdcd1f0ec375896a5a.jpeg",
    "https://cdn.faire.com/fastly/d2431a9d3762d69f31aee7273df5cb685ab1e90abf91f508d52968a5c5737e92.jpeg",
    "https://cdn.faire.com/fastly/aad93aab3c2d57aa3ac7b7aa1f1d3fea8819037dc7c548558ffe91b12ffd990c.jpeg",
    "https://cdn.faire.com/fastly/d3d06a16ad7127e7ae284456d6a2ecddd7adafb02fb72db6309377d7bae05942.jpeg",
    "https://cdn.faire.com/fastly/aa9a5e86f4e6d4e193718d7ecc5ce2e41343793987d08bebddc47fc4fb4aea3f.jpeg",
    "https://cdn.faire.com/fastly/a7d4456b63a6a961c23b8328afa0a5719907262ebabb0f4a58ba6a5dc54354f3.jpeg",
  ],
  priceDollars: 8.61,
  description:
    "Be on-trend with these birth year necklaces! Simplistic chain with your birth year in old English font in the middle. Makes for such a personal gift!\n\n- Dimensions: 16-inch chain necklace with a 2.5-inch extender. \n- Stainless Steel 18 K gold plated \n- Years between 1990-2002",
  tags: [],
  msrpDollars: 17.22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:58.212Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
